import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPhone',
    standalone: true
})
export class FormatPhonePipe implements PipeTransform {

    private readonly PHONE_FORMAT_REGEX = /^(\d{3})(\d{3})(\d{4})$/;

    transform(phone: string | null | undefined): string {
        if (!phone) return '';

        return phone
            .replace(/\D+/g, '')
            .replace(this.PHONE_FORMAT_REGEX, '$1-$2-$3')
            .trimEnd();
    }
}
